import { Stack, Typography, useTheme } from '@mui/material'
import BlankRect from './BlankRect'
import RowStack from './container/RowStack'
import BoxWithBackground from './container/BoxWithBackground'
import InCardStack from './container/InCardStack'
import colors from 'styles/colors'

const BlankEventItem = ({
  showConfirm,
  showReject,
  description,
  backgroundColor,
  rectColor = colors.MetalGrey75
}) => {
  const theme = useTheme()
  return (
    <>
      {description && (
        <Typography width='100%'>
          {description}
        </Typography>
      )}
      <BoxWithBackground
        borderRadius={4}
        sx={{ width: '100%', padding: 8, paddingY: 10.5 }}
        backgroundColor={backgroundColor || theme.palette.background.paper}>
        <RowStack justifyContent='space-between'>
          <RowStack spacing={8}>
            <Stack padding={0} spacing={2}>
              <BlankRect w={180} h={22} color={rectColor} />
              <BlankRect w={130} h={14} color={rectColor} />
            </Stack>
          </RowStack>
          <RowStack spacing={4} width='unset'>
            {showConfirm && (
              <BlankRect
                w={120}
                h={32}
                sx={{ borderRadius: 16 }}
                color={rectColor}
              />
            )}
            {showReject && (
              <BlankRect
                w={32}
                h={32}
                sx={{ borderRadius: 16 }}
                color={rectColor}
              />
            )}
          </RowStack>
        </RowStack>
      </BoxWithBackground>
    </>
  )
}

export const BlankNotesItem = ({
  rectColor = colors.Grey100,
  containerSx = {}
}) => {
  const reactProps = {
    color: rectColor,
    sx: {
      padding: 0,
      borderRadius: 2
    }
  }
  return (
    <InCardStack spacing={8} alignItems={'flex-start'} sx={containerSx}>
      <RowStack spacing={4}>
        <BlankRect w={8} h={8} {...reactProps} />
        <BlankRect w={189} h={8} {...reactProps} />
      </RowStack>
      <RowStack spacing={4}>
        <BlankRect w={8} h={8} {...reactProps} />
        <BlankRect w={227} h={8} {...reactProps} />
      </RowStack>
      <RowStack spacing={4}>
        <BlankRect w={8} h={8} {...reactProps} />
        <BlankRect w={164} h={8} {...reactProps} />
      </RowStack>
      <BlankRect w={434} h={8} {...reactProps} />
      <BlankRect w={434} h={8} {...reactProps} />
      <BlankRect w={351} h={8} {...reactProps} />
    </InCardStack>
  )
}

export default BlankEventItem
